import {AnyAction} from 'redux';
import {Coordinate, FeatureFilter} from '../types';
import {ReducerState} from '../utils';
import {ConfigActionType} from '../actionTypes';

/**
 * Stav konfigurace mapy.
 */
export interface ConfigState extends ReducerState<ConfigState> {
    /**
     * Téma konfigurace.
     */
    topic?: string;

    /**
     * ID podkladové vrstvy.
     */
    backgroundLayer?: string;

    /**
     * ID popisné vrstvy.
     */
    foregroundLayer?: string | null;

    /**
     * ID viditelných datových vrstev.
     */
    layers?: string[];

    /**
     * ID rozbalených položek katalogu.
     */
    catalogNodes?: string[];

    /**
     * Pozice středu mapy.
     */
    location?: Coordinate;

    /**
     * Přiblížení mapy.
     */
    zoom?: number;

    /**
     * Filtr obsahu datových vrstev.
     */
    filter?: FeatureFilter;

    /**
     * Klíč používaný při perzistenci stavu do local storage.
     */
    localStorageKey?: string;
}

/**
 * Výchozí stav konfigurace mapy.
 *
 * @ignore
 */
const initialState: ConfigState = {
    reducer: ConfigReducer,
};

/**
 * Reducer stavu konfigurace mapy.
 *
 * @param state - Aktuální stav.
 * @param action - Akce.
 * @returns Nový stav.
 * @ignore
 */
export default function ConfigReducer(state: ConfigState = initialState, action?: AnyAction): ConfigState {
    if (!action) {
        return state;
    }

    switch (action.type) {
        case ConfigActionType.SET_TOPIC:
            return {
                ...state,
                topic: action.topic,
            };

        case ConfigActionType.SET_BACKGROUND_LAYER:
            return {
                ...state,
                backgroundLayer: action.layerId,
            };

        case ConfigActionType.SET_FOREGROUND_LAYER:
            return {
                ...state,
                foregroundLayer: action.layerId,
            };

        case ConfigActionType.SET_LAYERS:
            return {
                ...state,
                layers: action.layerIds,
            };

        case ConfigActionType.SET_CATALOG_NODES:
            return {
                ...state,
                catalogNodes: action.nodeIds,
            };

        case ConfigActionType.SET_LOCATION:
            return {
                ...state,
                location: action.location,
            };

        case ConfigActionType.SET_ZOOM:
            return {
                ...state,
                zoom: action.zoom,
            };

        case ConfigActionType.SET_FILTER:
            return {
                ...state,
                filter: action.filter,
            };

        default:
            return state;
    }
}
